<template>
    <base-layout >
        <ion-grid>
            <ion-row>
                <ion-col size="12" >
                    <ion-input type="text" id="serverUrl" name="serverUrl" v-model="serverUrl" placeholder="server url" />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6" >
                    <ion-button @click="save" >
                        Save
                    </ion-button>    
                </ion-col>
                <ion-col size="6" >
                    <ion-button @click="cancel" >
                        Cancel
                    </ion-button>    
                </ion-col>
            </ion-row>
        </ion-grid>
    </base-layout>
</template>

<script>
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/vue';

export default {
    components: { IonButton, IonCol, IonGrid, IonRow },

    data(){
        return {
            serverUrl: ''
        }
    },

    methods: {
        save(){
            this.$router.replace('/home');
        },

        cancel(){
            this.$router.replace('/home');
        }
    }
}
</script>

<style>

    ion-grid{
        height: 100%;
    }    

    ion-row {
        height: 50%;
    }

</style>